import React from 'react';
import { HomeSectionHeader } from '../home/HomeSectionHeader';
import { HOME_SURFACES } from '../home/homeSurfaces';

export function MarketingPageCta({
  badge,
  title,
  subtitle,
  actions,
}: {
  badge?: string;
  title: string;
  subtitle?: string;
  actions: React.ReactNode;
}): React.JSX.Element {
  return (
    <section className={HOME_SURFACES.deep}>
      <div className="section-padding">
        <div className="max-w-4xl">
          <HomeSectionHeader
            badge={badge}
            title={title}
            subtitle={subtitle}
            light
            className="mb-10"
          />
          <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap">
            {actions}
          </div>
        </div>
      </div>
    </section>
  );
}
